import { FormikProps } from 'formik';
import { useEffect, useState } from 'react';
import {
    Account,
    AccountAddress,
    AccountContactPerson,
    AccountSpecialCondition,
} from '../../../../shared/types/modules/account';
import { ToastSwal } from '../../../components/general/toastSwals/toastSwal';
import { asyncCreatePqrWeb } from '../../../../services/pqr.service';
import {
    PqrInfoWeb,
    PqrResponseMedium,
} from '../../../../shared/types/modules/pqr';
import { asyncGetParams } from '../../../../services/param.service';
import { Attachment, ParamEnum } from '../../../../shared/types/shared';

export const usePqrWebForm = () => {
    const [loading, setLoading] = useState(false);
    const [formikContactPerson, setFormikContactPerson] =
        useState<FormikProps<AccountContactPerson>>();
    const [formikAddress, setFormikAddress] =
        useState<FormikProps<AccountAddress>>();
    const [formikSpecialCondition, setFormikSpecialCondition] =
        useState<FormikProps<AccountSpecialCondition>>();
    const [formikPqrInfoWeb, setFormikPqrInfoWeb] =
        useState<FormikProps<PqrInfoWeb>>();
    const [formikPqrResponseMedium, setFormikPqrResponseMedium] =
        useState<FormikProps<PqrResponseMedium>>();
    const [showForm, setShowForm] = useState(true);
    const [consecutiveFormat, setConsecutiveFormat] = useState('');
    const [open, setOpen] = useState(false);
    const [receptionChannel, setReceptionChannel] = useState<number | string>(
        ''
    );
    const [receptionInstance, setReceptionInstance] = useState<number | string>(
        ''
    );
    const [attachments, setAttachments] = useState<Attachment[]>([]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_RECEPTION_CHANNEL).then((items) => {
            const filterWeb =
                items?.filter(
                    (item) =>
                        item.code === `${ParamEnum.PQR_RECEPTION_CHANNEL}_WEB`
                )[0] || undefined;
            setReceptionChannel(filterWeb?.id);
        });
        asyncGetParams(ParamEnum.PQR_RECEPTION_INSTANCE).then((items) => {
            const filterInstance =
                items?.filter(
                    (item) =>
                        item.code === `${ParamEnum.PQR_RECEPTION_INSTANCE}_EVG`
                )[0] || undefined;
            setReceptionInstance(filterInstance?.id);
        });
    }, []);

    const isValidForm =
        formikContactPerson?.isValid &&
        formikSpecialCondition?.isValid &&
        formikPqrInfoWeb?.isValid &&
        formikAddress?.isValid &&
        formikPqrResponseMedium?.isValid;

    const handleSubmit = async () => {
        if (process.env.REACT_APP_PQR_WEB_RADICATION_ENABLED !== 'true') return;

        await formikContactPerson?.submitForm();
        await formikSpecialCondition?.submitForm();
        await formikPqrInfoWeb?.submitForm();
        await formikAddress?.submitForm();
        await formikPqrResponseMedium?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: any = formikContactPerson?.values as Account;
        data.address = formikAddress?.values;
        data.specialCondition = formikSpecialCondition?.values;
        data.country = formikPqrInfoWeb.values.country;
        data.channelPresentsFailure =
            formikPqrInfoWeb.values.channelPresentsFailure;
        data.location = formikPqrInfoWeb.values.location;
        data.detail = formikPqrInfoWeb.values.detail;
        data.type = formikPqrInfoWeb.values.type;
        data.receptionChannel = receptionChannel;
        data.receptionInstance = receptionInstance;
        data.responseMedium = formikPqrResponseMedium.values?.responseMedium;
        data.attachments = attachments;

        let res: any | undefined = undefined;

        try {
            res = await asyncCreatePqrWeb(data);
        } catch (error) {}

        if (!res) {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo radicar intentelo más tarde`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
        return res;
    };

    const handleClean = () => {
        formikContactPerson?.resetForm();
        formikAddress?.resetForm();
        formikSpecialCondition?.resetForm();
        formikPqrInfoWeb?.resetForm();
        formikPqrResponseMedium?.resetForm();
    };

    const handleFormSubmit = async () => {
        try {
            const response = await handleSubmit();
            if (response?.consecutiveFormat) {
                setConsecutiveFormat(response.consecutiveFormat);
                setShowForm(false);
            } else {
                console.error(
                    'La respuesta no contiene el formato consecutivo:',
                    response
                );
            }
        } catch (error) {
            console.error('Error al guardar el formulario:', error);
        }
    };

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return {
        loading,
        isValidForm,
        handleClean,
        handleFormSubmit,
        handleOpen,
        handleClose,
        open,
        showForm,
        consecutiveFormat,
        formikPqrInfoWeb,
        setFormikContactPerson,
        setFormikSpecialCondition,
        setFormikPqrInfoWeb,
        setFormikAddress,
        setFormikPqrResponseMedium,
        setAttachments,
    };
};
